(ns frontend.ui.component.card.style
  (:require
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.style.theme.core :refer [border-radius color edge-size]]
   [garden.util :refer [space-join]]))

(defn head
  [{:keys [disabled? on-click]}]
  (merge
   {:display         "flex"
    :justify-content "space-between"
    :padding         (edge-size :medium)
    :align-items     "center"}
   (cond disabled?
         {:color (theme/color [:card :head :disabled])}
         on-click
         {:cursor "pointer"})))

(defn head-left
  []
  {:display     "flex"
   :flex        "1 0 auto"
   :align-items "center"
   :max-width   "80%"})

(defn head-right
  []
  {:display     "flex"
   :flex        "0 0 auto"
   :align-items "end"})

(defn body
  [collapsed?]
  {:padding    "16px 24px"
   :border-top (space-join ["1px solid " (theme/color [:card :body :border-top])])
   :display    (when collapsed?
                 "none")})

(defn card
  []
  {:margin           "0 0 24px"
   :border-radius    (border-radius :xxxsmall)
   :background-color (color [:card :body :bg])
   :box-shadow       (space-join ["0 3px 6px" (theme/color [:card :card :box-shadow])])})
